import { ReactComponent as Explore } from 'assets/icons/icon-explore.svg';

export default Explore;
